import React from 'react'
import PropTypes from 'prop-types'

import { Redirect, Route } from 'react-router-dom'

export const PublicRoute = ({
    isAuthenticated,
    component: Component,
    ...rest
}) => {
        return (
            <Route {...rest}
                component={
                    (props) => (
                        (!isAuthenticated ) ? <Component  {...props} /> : <Redirect to="/"/>
                    )
                }
            />
            //Si no está autenticado carga el componente
            //Si lo está, redirecciona al '/'
            //De esta forma, si estoy autenticado y me voy al /login, me redirecciona 
        )
}

PublicRoute.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    component : PropTypes.func.isRequired
}
